import { render } from "./FeeStatement.vue?vue&type=template&id=6219c60f&scoped=true"
import script from "./FeeStatement.vue?vue&type=script&lang=js"
export * from "./FeeStatement.vue?vue&type=script&lang=js"

import "./FeeStatement.vue?vue&type=style&index=0&id=6219c60f&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6219c60f"]])

export default __exports__